import { z } from 'zod';
import moment from 'moment';

export const toDateString = (value: unknown): unknown => {
  if (value === null || value === undefined || value === '') return null;
  if (moment.isMoment(value)) return value.isValid() ? value.toISOString() : null;
  if (value instanceof Date) return moment(value).toISOString();
  return value;
};

export const dateStringSchema = z.preprocess(toDateString, z.string().nullable());

export const EventNoteSchema = z.object({
  id: z.string(),
  content: z.string(),
  createdById: z.string(),
  eventActivityId: z.string(),
  createdDateTime: z.string(),
});

export const ReDateEventSchema = z.object({
  id: z.string().uuid(),
  endAt: z.string().nullable().optional(),
  endDate: z.string().nullable().optional(),
  startAt: z.string().nullable().optional(),
  allDay: z.boolean().nullable().optional(),
  startDate: z.string().nullable().optional(),
});

export const ReDateEventInputSchema = z.object({
  input: z.object({
    events: z.array(ReDateEventSchema),
  }),
});

export const ReDateEventsToDateInputSchema = z.object({
  input: z.object({
    ids: z.array(z.string()),
    /** Calendar date formatted as YYYY-MM-DD. */
    date: z.string(),
    /** IANA time zone, e.g. "America/Los_Angeles". */
    timeZone: z.string(),
  }),
});
